module.exports = __webpack_public_path__ + "static/media/plus-sign-grey.7fc263f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/plus-sign-grey.svg
// module id = 858
// module chunks = 0